var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 53,
    viewBox: "0 0 32 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1626 0.871497C30.8976 0.603996 30.5829 0.39177 30.2365 0.246969C29.8901 0.102167 29.5187 0.027633 29.1437 0.027633C28.7686 0.027633 28.3972 0.102167 28.0508 0.246969C27.7044 0.39177 27.3897 0.603996 27.1248 0.871497L16.0137 12.0386L4.87403 0.842641C4.60891 0.575491 4.29416 0.363575 3.94776 0.218995C3.60135 0.0744139 3.23008 2.81488e-09 2.85514 0C2.4802 -2.81488e-09 2.10893 0.074414 1.76253 0.218995C1.41612 0.363575 1.10138 0.575491 0.836251 0.842641C0.571126 1.10979 0.360818 1.42694 0.217334 1.77599C0.0738496 2.12504 -2.79354e-09 2.49915 0 2.87696C2.79354e-09 3.25477 0.0738496 3.62887 0.217334 3.97792C0.360818 4.32697 0.571126 4.64413 0.836251 4.91128L13.9805 18.156C15.0973 19.2813 16.9015 19.2813 18.0183 18.156L31.1626 4.91128C31.4278 4.64718 31.6385 4.33265 31.7822 3.98592C31.926 3.63919 32 3.26716 32 2.89139C32 2.51561 31.926 2.14358 31.7822 1.79685C31.6385 1.45012 31.4278 1.13559 31.1626 0.871497Z",
    fill: "url(#paint0_linear_1420_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1582 17.8715C30.8931 17.604 30.5781 17.3918 30.2314 17.247C29.8847 17.1022 29.5131 17.0276 29.1377 17.0276C28.7624 17.0276 28.3907 17.1022 28.044 17.247C27.6973 17.3918 27.3824 17.604 27.1173 17.8715L15.9976 29.0386L4.87783 17.8426C4.34197 17.3031 3.61519 17 2.85737 17C2.09955 17 1.37277 17.3031 0.836905 17.8426C0.301044 18.3822 0 19.1139 0 19.877C0 20.64 0.301044 21.3717 0.836905 21.9113L13.9914 35.156C15.1091 36.2813 16.9146 36.2813 18.0323 35.156L31.1869 21.9113C31.713 21.3706 32.0053 20.6423 31.9999 19.8854C31.9946 19.1285 31.692 18.4045 31.1582 17.8715Z",
    fill: "url(#paint1_linear_1420_14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1582 34.8715C30.8931 34.604 30.5781 34.3918 30.2314 34.247C29.8847 34.1022 29.5131 34.0276 29.1377 34.0276C28.7624 34.0276 28.3907 34.1022 28.044 34.247C27.6973 34.3918 27.3824 34.604 27.1173 34.8715L15.9976 46.0386L4.87783 34.8426C4.34197 34.3031 3.61519 34 2.85737 34C2.09955 34 1.37277 34.3031 0.836905 34.8426C0.301044 35.3822 0 36.1139 0 36.877C0 37.64 0.301044 38.3717 0.836905 38.9113L13.9914 52.156C15.1091 53.2813 16.9146 53.2813 18.0323 52.156L31.1869 38.9113C31.713 38.3706 32.0053 37.6423 31.9999 36.8854C31.9946 36.1285 31.692 35.4045 31.1582 34.8715Z",
    fill: "url(#paint2_linear_1420_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1420_14",
    x1: 16,
    y1: -9,
    x2: 16,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142498,
    stopColor: "#0E3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663362,
    stopColor: "#FBA346"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1420_14",
    x1: 16,
    y1: -9,
    x2: 16,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142498,
    stopColor: "#0E3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663362,
    stopColor: "#FBA346"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1420_14",
    x1: 16,
    y1: -9,
    x2: 16,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142498,
    stopColor: "#0E3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663362,
    stopColor: "#FBA346"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.40843ecb664074131d362f0978580c97.svg";
export { ForwardRef as ReactComponent };